import axios from "axios";
import { BASE_URL } from "./Constants";

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

export async function getSerieStats(ids, startDate, endDate) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.get(
      `/stats/serie?startDate=${startDate}&endDate=${endDate}&ids=${ids.join(
        ","
      )}`
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}
